import React from 'react';
import { Ticket } from '@marageti/z4-sdk/lib/tickets';
import TicketSummaryItem from './ticket-summary-item';
import SummaryCard from '../summary-card';

type TicketsSummaryViewProps = {
  tickets: Ticket[];
  isLoading: boolean;
  hasMore: boolean;
  emptyMessage?: string;
  onAddTicket: () => void;
  onSeeMore: () => void;
};

const TicketsSummaryView = ({
  tickets,
  isLoading,
  hasMore,
  emptyMessage = 'There are no tickets for this trip.',
  onAddTicket,
  onSeeMore,
}: TicketsSummaryViewProps) => (
  <SummaryCard
    title="Tickets"
    isLoading={isLoading}
    isEmpty={tickets.length === 0}
    emptyMessage={emptyMessage}
    hasMore={hasMore}
    onAdd={onAddTicket}
    onSeeMore={onSeeMore}
  >
    {tickets.map((ticket) => (
      <TicketSummaryItem key={ticket.id} ticket={ticket} />
    ))}
  </SummaryCard>
);

export default TicketsSummaryView;
